import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { EaseTable } from '../../../libs/EaseTable';
import { handleApiExceptions, generate_query_set } from '../../../app_methods';
import { getBulkUploadsTableColumns, bulkUploadsTableFilterNodes } from './constants';
import { BulkUploadBatch } from '../../../models';
import { BulkUploadModal, ContentCard, PaginationKaBaap } from '../../Common';
import { RecordsDrawer } from './records_drawer';
import { ApprovalsDrawer } from './approval_drawer'
import { connect } from 'react-redux';
import { updateCurrentUserAction } from '../../../redux/actions';
import { CreatePermissionHoc, PermissionHoc } from '../../HOC';



const BulkOperations = (props) => {
    const [bulkUploads, setBulkUploads] = useState([]);
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [pagination, setPagination] = useState({
        pageSize: 15,
        current: 1,
        hasNext: true,
        showing: { from: 1, to: 15 }
    });
    const [filters, setFilters] = useState({ batch_type: props.match.params.batch_type? props.match.params.batch_type: "transfer" });
    const [showRecordsDrawer, setShowRecordsDrawer] = useState(false);
    const [showApprovalsDrawer, setShowApprovalsDrawer] = useState(false);
    const [selectedBatch, setSelectedBatch] = useState({});
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);


    const prepFilters = (filters) => {
        let _filters = { ...filters };
        if (_filters.created_at && _filters.created_at.length) {
            _filters.created_at_start = _filters.created_at[0].format("YYYY-MM-DD");
            _filters.created_at_end = _filters.created_at[1].format("YYYY-MM-DD");
            delete _filters.created_at;
        }
        return _filters;
    };

    const fetchBulkUploads = async (_pagination = pagination, _filters = filters) => {
        if (!props.current_user.key) return;
        setIsTableLoading(true);
        const response = await BulkUploadBatch.list_v2({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ...prepFilters(_filters) });
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        let queryset = generate_query_set(BulkUploadBatch, response.data.results);
        // queryset = queryset.map((batch) => { return { ...batch, is_submerchant:!!_filters.submerchant_id, submerchant: _filters.submerchant_id}})
        if (selectedBatch.id) setSelectedBatch(queryset.find(batch => batch.id == selectedBatch.id));
        setBulkUploads(queryset);
        setPagination({ ..._pagination, ...response.data.pagination});
        setIsTableLoading(false);
    };

    const toggleRecordsDrawer = (record = {}) => {
        setSelectedBatch(record);
        setShowRecordsDrawer(!showRecordsDrawer);
    };

    const toggleApprovalsDrawer = (record = {}) => {
        setSelectedBatch(record);
        setShowApprovalsDrawer(!showApprovalsDrawer);
    };

    const handleTableChange = (tableInfo) => {
        if (tableInfo.trigger == "columns") return;
        let _pagination = tableInfo.pagination;
        if (tableInfo.trigger == "filters") _pagination.current = 1;
        setPagination(_pagination);
        setFilters(tableInfo.filters);
        fetchBulkUploads(_pagination, tableInfo.filters);
    };

    const tableColumns = getBulkUploadsTableColumns({ toggleRecordsDrawer: toggleRecordsDrawer, toggleApprovalsDrawer: toggleApprovalsDrawer });
    // const filterNodes = bulkUploadsTableFilterNodes({batch_type: props.match.params.batch_type? props.match.params.batch_type: "transfer"}, props.current_user);
    const filterNodes = bulkUploadsTableFilterNodes({batch_type: props.match.params.batch_type? props.match.params.batch_type: "transfer"});


    useEffect(() => {
        props.onChildMount();
        let defaultFilters = {};
        filterNodes.forEach(f => defaultFilters[f.field] = f.defaultValue);
        setFilters({ ...filters, ...defaultFilters });
        fetchBulkUploads(pagination, { ...filters, ...defaultFilters });
    }, []);

    const onPageChange = (_pagination) => {
        setPagination({ ..._pagination });
        fetchBulkUploads({ ..._pagination }, filters);
    };


    return (
        <ContentCard className="p-3">
            <EaseTable
                rowKey="uuid"
                loading={isTableLoading}
                data={bulkUploads}
                columns={tableColumns}
                fixedSelectable={!isMobile}
                handleTableChange={handleTableChange}
                // pagination={pagination}
                // totalRecords={pagination.total}
                filterNodes={filterNodes}
            /><PaginationKaBaap pageChange={onPageChange} pagination={pagination} />
            <RecordsDrawer
                visible={showRecordsDrawer}
                toggleRecordsDrawer={toggleRecordsDrawer}
                batch={selectedBatch}
                fetchBulkUploads={fetchBulkUploads}
                isTableLoading={isTableLoading}
                threshold_percentage={props.current_user.fuzzy_check_threshold_percentage}
            />
            <ApprovalsDrawer 
                visible={showApprovalsDrawer}            
                toggleApprovalsDrawer={toggleApprovalsDrawer}
                batch={selectedBatch}
                fetchBulkUploads={fetchBulkUploads}
                user={props.current_user}
            />
        </ContentCard>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionHoc(BulkOperations,'BULK_OPERATIONS_READ'));